import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import Visits from '../../Modules/visits/components/Visits';
import NurseDeployments from '../../Modules/nurseDeployments/components/NurseDeployments';
import CustomerNotesForm from '../../Modules/interestedCustomer/components/CustomerNotesForm';
import CustomerDocumentTitle from './CustomerDocumentTitle';
import { useCanWrite } from '../../Modules/abilities/hooks';
import {
    CUSTOMER_NURSE_DEPLOYMENTS_DEMANDS,
    CUSTOMER_NURSE_DEPLOYMENTS_NOTES,
    CUSTOMER_NURSE_DEPLOYMENTS_VISITS,
} from '../../Modules/api/resources';
import { useCareNeedsByCustomerId } from '../../Modules/careNeeds/careNeedsSlice';
import { useSnackbar } from '../../Modules/snackbar/hooks';

import {
    useNurseDeploymentsByCustomerId
} from '../../Modules/nurseDeployments/nurseDeploymentsSlice';
import { checkActiveInctiveBalance} from '../../Modules/nurseDeployments/helpers';

/**
 * "BK-Verlauf" Sub-Page
 */
const NurseDeploymentsPage = () => {
    const { id: customerId } = useParams();
    const canWriteCustomerNurseDeploymentsDemands = useCanWrite(CUSTOMER_NURSE_DEPLOYMENTS_DEMANDS);
    const canWriteCustomerNurseDeploymentsNotes = useCanWrite(CUSTOMER_NURSE_DEPLOYMENTS_NOTES);
    const canWriteCustomerNurseDeploymentsVisits = useCanWrite(CUSTOMER_NURSE_DEPLOYMENTS_VISITS);
    const { enqueueSnackbar , closeSnackbar} = useSnackbar();
    const [careNeeds] = useCareNeedsByCustomerId(customerId);
    const [allNurseDeploymentsByCustomerId] = useNurseDeploymentsByCustomerId(customerId);

     useEffect(() => {
        if (!careNeeds || careNeeds.length === 0 || careNeeds.length <= 1) {
            closeSnackbar('multiple-care-needs');
            return;
        }

        // Wait until after the DOM has been painted
        setTimeout(() => {
            const in_balance = checkActiveInctiveBalance(allNurseDeploymentsByCustomerId, careNeeds);
            if (in_balance === true) {
                closeSnackbar('multiple-care-needs');
            }else {
                // Show a snackbar with the error message
                let errorMessage = `Mehrere aktive Bedarfsschienen vorhanden! \nBitte diese auf inhaltliche Richtigkeit hin überprüfen!`;
                enqueueSnackbar(
                    errorMessage,
                    {
                        key: 'multiple-care-needs',
                        variant: 'error',
                        persist: true,
                        style: { whiteSpace: 'pre-line' },
                        preventDuplicate: true
                    }
                );
            }
        }, 0);
    }, [careNeeds, allNurseDeploymentsByCustomerId, enqueueSnackbar, closeSnackbar]);

    return (
        <>
            <CustomerDocumentTitle customerId={customerId} prefix="BK-Verlauf" />

            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <CustomerNotesForm customerId={customerId} disabled={!canWriteCustomerNurseDeploymentsNotes} />
                </Grid>
                <Grid item xs={12}>
                    <Visits customerId={customerId} disabled={!canWriteCustomerNurseDeploymentsVisits} />
                </Grid>
                <Grid item xs={12}>
                    <NurseDeployments customerId={customerId}  disabled={!canWriteCustomerNurseDeploymentsDemands} />
                </Grid>
            </Grid>
        </>
    );
};

NurseDeploymentsPage.propTypes = {};

export default NurseDeploymentsPage;
